module.exports = __webpack_public_path__ + "static/media/photocell.9ff35929.jpg";